import { types } from "../types/types";

// Acción síncrona para guardar las opciones
export const setCompaniesHoldingOptions = (options) => ({
  type: types.setCompaniesHoldingOptions,
  payload: options
});

// Acción síncrona para guardar las empresas seleccionadas
export const setSelectedCompanies = (companies) => ({
  type: types.setSelectedCompanies,
  payload: companies
});

// Acción asíncrona (ejemplo de cómo podrías usarla)
export const fetchAndSetCompaniesOptions = (optionsData) => {
  return (dispatch) => {
    try {
      dispatch(setCompaniesHoldingOptions(optionsData));
    } catch (error) {
      console.error("Error setting companies options:", error);
    }
  };
};